import { render, staticRenderFns } from "./DownloadArrow.vue?vue&type=template&id=b5a0f3e8&"
import script from "./DownloadArrow.vue?vue&type=script&lang=js&"
export * from "./DownloadArrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports